import React, { useState } from "react";
import { Box, Container, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import Meta from "../../components/common/Meta";
import { DrawerHeader } from "../../components/layout/Drawer/DrawerMain";
import MindMapGeneratorPanel from "./MindMapGeneratorPanel";
import MindMapLibraryPanel from "./MindMapLibraryPanel";
import { uiHeight } from "../../utils/uiHeight";
import { alpha } from "@mui/material/styles";

const MindMapPage: React.FC = () => {
  const { t } = useTranslation();
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleMindMapGenerated = () => {
    // ライブラリの更新をトリガー
    setRefreshTrigger((prev) => prev + 1);
  };

  return (
    <Box sx={{}}>
      <Meta title={t("mindmap.title")} meta={[{ name: "robots", content: "noindex, nofollow" }]} />
      <DrawerHeader />

      <Container
        maxWidth={false}
        sx={{
          py: 2,
          display: "flex",
          flexDirection: "column",
          height: uiHeight(),
        }}
      >
        <Grid container spacing={2} sx={{ flex: 1, overflow: "hidden" }}>
          {/* 左側：マインドマップ生成パネル */}
          <Grid
            size={{
              xs: 12,
              sm: 12,
              md: 5,
            }}
          >
            <Box
              sx={{
                height: "100%",
                overflow: "auto",
                display: "flex",
                flexDirection: "column",
                backgroundColor: (theme) => alpha(theme.palette.background.custom1, 0.5),
                backdropFilter: "blur(10px)",
                borderRadius: 2,
              }}
            >
              <MindMapGeneratorPanel onMindMapGenerated={handleMindMapGenerated} />
            </Box>
          </Grid>

          {/* 右側：マインドマップライブラリパネル */}
          <Grid
            size={{
              xs: 12,
              sm: 12,
              md: 7,
            }}
          >
            <Box
              sx={{
                height: "100%",
                flexDirection: "column",
                backgroundColor: (theme) => alpha(theme.palette.background.custom1, 0.5),
                borderRadius: 2,
                backdropFilter: "blur(10px)",
              }}
            >
              <MindMapLibraryPanel refreshTrigger={refreshTrigger} />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default MindMapPage;
